var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"d":"M.686 12L12 23.314 23.314 12 12 .686"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }